import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertCircle, ArrowLeft, Home } from 'lucide-react';

interface GenericErrorProps {
  title: string;
  description: string;
  statusCode: number;
  statusText: string;
}

export default function GenericError({
  title,
  description,
  statusCode,
  statusText,
}: GenericErrorProps) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="flex-col bg-[#111] p-6">
      <Card className="mx-auto w-full max-w-4xl border-[#2E3835] bg-card2 text-white">
        <CardHeader className="border-b border-[#2E3835]">
          <div className="flex items-center">
            <AlertCircle className="mr-3 h-8 w-8 text-red-500" />
            <div>
              <CardTitle className="text-2xl text-white">{title}</CardTitle>
              <CardDescription className="text-gray-400">{description}</CardDescription>
            </div>
          </div>
        </CardHeader>

        <CardContent className="pt-6">
          <div className="mb-6 text-center">
            <div className="mb-4 text-9xl font-bold">{statusCode}</div>
            <p className="mb-8 text-white">{statusText}</p>

            <div className="flex flex-col justify-center gap-4 sm:flex-row">
              <Button
                variant="outline"
                onClick={handleGoBack}
                className="border-[#2E3835] hover:bg-[#2E3835]"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Go Back
              </Button>
              <Button onClick={handleGoHome} className="bg-[#B7D257] text-black hover:bg-[#D1E47F]">
                <Home className="mr-2 h-4 w-4" />
                Go to Home
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
